import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { strings } from '../../resources/strings';
import { ServiceOnDemandSchedules } from './ServiceOnDemandSchedules';

export class ServiceOnDemand extends Component {
    render() {
        return (
            <Container fluid>
                <Row>
                    <Col>
                        <div className="mt-5">
                            <h2><strong>{strings.serviceOnDemand}</strong></h2>
                            <br></br>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <div>
                        <p dangerouslySetInnerHTML={{ __html: strings.serviceOnDemandAbout }} />
                        <p dangerouslySetInnerHTML={{ __html: strings.serviceOnDemandDescription }} />
                        <ServiceOnDemandSchedules />
                        <p dangerouslySetInnerHTML={{ __html: strings.serviceOnDemandMoreInfo }} />
                    </div>
                </Row>
            </Container>
        );
    }
}